module.exports = "/dist/assets/images/android-chrome-512x512.png";